export default __webpack_public_path__ + "static/media/bordeau.bd95ed05.svg";